export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_LIMITS = {
    maxPageSize: 100,
    maxOffset: 10_000,
    maxFilterLength: 2000,
    maxComparisons: 20,
    maxDepth: 5,
    maxListValues: 50,
    maxValueLength: 320,
    maxSortFields: 3,
};
/** Combina os limites de uma política com os padrões, só para baixo. */
export function limitsWith(overrides = {}) {
    const merged = { ...DEFAULT_LIMITS };
    for (const key of Object.keys(DEFAULT_LIMITS)) {
        const override = overrides[key];
        if (override !== undefined) {
            merged[key] = Math.min(override, DEFAULT_LIMITS[key]);
        }
    }
    return merged;
}
//# sourceMappingURL=limits.js.map